<template>
  <div class="product-bubble-wrapper">
    <div v-show="showBubble" class="product-bubble thead-bubble shipping-packing-thead-bubble" @mouseover="handleMouseOver()" @mouseleave="handleMouseLeave()" v-html="bubbleText" />
    <div>
      出荷時の梱包
      <i class="fa fa-question-circle thead-bubble-icon"
        @mouseover="handleMouseOver()"
        @mouseleave="handleMouseLeave()"
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showBubble: false
    }
  },
  computed: {
    bubbleText () {
      return `出荷時の梱包について以下より選択してください。<br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;・通常梱包で出荷：倉庫側で梱包して出荷します。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;・納品時の梱包のまま出荷：納品した荷姿のまま直接送り状を貼付して出荷します。<br/>壊れやすい商品は、セラー様にて壊れにくい包装としていただくようにお願いします。`
    }
  },
  methods: {
    handleMouseOver () {
      this.showBubble = true
    },
    handleMouseLeave () {
      this.showBubble = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/ShippingPackingThead.vue